export const numberWithCommas = (x: any) => {
  const decimalComma = x;
  const parts = decimalComma.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts.join(',');
};
